import { formatDate } from "../../../utility/formatDate";
import CourseActions from "../../../pages/Admin/Courses/components/CourseActions";

export const getCourseTableColumns = (navigate, handleEditClick, handleDeleteClick,status) => [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
   
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
     {
      title: "Level",
      dataIndex: "level",
      key: "level",
    },
    {
      title: "Owner",
      dataIndex: "ownerName",
      key: "ownerName",
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => formatDate(date, "DD MMM YYYY"),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date) => formatDate(date, "DD MMM YYYY"),
    },
    {
      title: "Action",
      width: 80,
      render: (_, record) => (
      <CourseActions
        record={record}
        navigate={navigate}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        status={status}
      />
    ),
    },
  ];